var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { conditions, Form, Interactor, Model, required } from '@veeam/core';
import { DatetimeInputContext } from "./..";
import { isOneDay } from "./helpers";
import { useContext } from 'react';
var DatePeriodMenuInteractor = /** @class */ (function (_super) {
    __extends(DatePeriodMenuInteractor, _super);
    function DatePeriodMenuInteractor(value, listener, config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var _this = _super.call(this) || this;
        _this.listener = listener;
        _this.config = config;
        _this.didApplySelect = function () {
            var _a, _b, _c, _d, _e, _f;
            if (!_this.form.validateAndDisplayErrors()) {
                return;
            }
            var values = _this.form.getValue();
            if (values.type === 'date' && values.date) {
                (_b = (_a = _this.listener).onSubmit) === null || _b === void 0 ? void 0 : _b.call(_a, [values.date]);
                return;
            }
            if (values.type === 'period' && values.startDate && values.endDate) {
                var end = new Date(values.endDate);
                end.setHours(24, 0, 0, 0);
                (_d = (_c = _this.listener).onSubmit) === null || _d === void 0 ? void 0 : _d.call(_c, [values.startDate, new Date(end.valueOf() - 1)]);
                return;
            }
            (_f = (_e = _this.listener).onSubmit) === null || _f === void 0 ? void 0 : _f.call(_e, []);
        };
        var initType = !value.length ? 'all' : value.length === 1 ? 'date' : 'period';
        if (value && value[0] && value[1] && isOneDay(value[0], value[1])) {
            initType = 'date';
            value = value.slice(0, 1);
        }
        var now = useContext(DatetimeInputContext).getNowTime();
        var defaultDate = ((_a = _this.config) === null || _a === void 0 ? void 0 : _a.defaultInitDate) || now;
        var defaultStartDate = ((_b = _this.config) === null || _b === void 0 ? void 0 : _b.defaultInitFromDate) || now;
        if (((_c = _this.config) === null || _c === void 0 ? void 0 : _c.defaultInitToDate) && ((_d = _this.config) === null || _d === void 0 ? void 0 : _d.defaultInitFromDate) &&
            ((_e = _this.config) === null || _e === void 0 ? void 0 : _e.defaultInitToDate) < ((_f = _this.config) === null || _f === void 0 ? void 0 : _f.defaultInitFromDate)) {
            console.warn('DatePeriodMenu Error: the value of "defaultInitFromDate" property must be greater than the value of "defaultInitToDate" property.');
        }
        var defaultEndDate = ((_g = _this.config) === null || _g === void 0 ? void 0 : _g.defaultInitToDate) ||
            new Date(defaultStartDate.getTime() + 1000 * 24 * 60 * 60);
        _this.form = new Form(new Model({
            type: initType,
            date: (initType === 'date' && value[0]) || defaultDate,
            startDate: (initType === 'period' && value[0]) || defaultStartDate,
            endDate: (initType === 'period' && value[1]) || defaultEndDate
        }), {
            validationSchema: {
                type: [required()],
                date: [conditions({ type: 'date' }, required((_h = _this.config) === null || _h === void 0 ? void 0 : _h.requireErrorText))],
                startDate: [
                    conditions({ type: 'period' }, required((_j = _this.config) === null || _j === void 0 ? void 0 : _j.requireErrorText))
                ],
                endDate: [
                    conditions({ type: 'period' }, required((_k = _this.config) === null || _k === void 0 ? void 0 : _k.requireErrorText))
                ]
            }
        });
        return _this;
    }
    return DatePeriodMenuInteractor;
}(Interactor));
export { DatePeriodMenuInteractor };
//# sourceMappingURL=DatePeriodMenuInteractor.js.map